var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"underline"},[_c('img',{staticClass:"body",style:(_vm.bodyStyle),attrs:{"src":_vm.bodySrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }